import { createBrowserRouter } from "react-router-dom";
import { Login } from 'modules/public';
import adminRoutes from './adminRoutes';
import ProtectedRoute from 'components/ProtectedRoute';
import RootPage from "modules/core";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootPage />,
    
    errorElement: (
      <div className="h-screen flex items-center justify-center text-xl font-bold italic">
        ERROR
      </div>
    ),
    children: [...adminRoutes].map((foo) => {
      return {
        ...foo,
        element: <ProtectedRoute routeItem={foo}>{foo.element}</ProtectedRoute>,
        
      };
    }),
  },

  {
    path: "/login",
    element: <Login></Login>,
  },
]);

export default router
